// drivers.js
import req from './axios';
import { isMockJs } from './axios'

export const getApplication = (sendData) => req('get', isMockJs ? '/download/application' : '/application/', sendData);
